var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.63,
    height: 37.928,
    viewBox: "0 0 40.63 37.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_9",
    "data-name": "\\u8DEF\\u5F84 9",
    d: "M3703.713,651.7c-.106.756-.184,1.518-.323,2.268a18.5,18.5,0,0,1-5.256,9.929,1.348,1.348,0,1,1-1.905-1.908,16.857,16.857,0,0,0,3.381-4.9,16.176,16.176,0,0,0-2.973-17.627c-.137-.144-.278-.283-.412-.43a1.361,1.361,0,0,1,.017-1.925,1.341,1.341,0,0,1,1.922.041,18.66,18.66,0,0,1,5.481,11.867,2.209,2.209,0,0,0,.068.3Zm-16.258-18.391c0-.159,0-.318-.006-.476a1.329,1.329,0,0,0-.963-1.224,1.5,1.5,0,0,0-1.451.412q-6.313,5.061-12.641,10.1a1.306,1.306,0,0,1-.745.254c-1.891.02-3.782.006-5.673.012a2.706,2.706,0,0,0-2.892,2.906q0,5.2,0,10.394a2.714,2.714,0,0,0,2.938,2.939c1.891,0,3.782-.007,5.673.011a1.183,1.183,0,0,1,.674.234q4.3,3.414,8.585,6.854c1.4,1.123,2.8,2.251,4.212,3.369a1.3,1.3,0,0,0,1.987-.161,2.046,2.046,0,0,0,.29-1.074q.025-8.668.012-17.336Zm9.566,11.439a13.232,13.232,0,0,0-2.661-3.769,1.354,1.354,0,0,0-1.635-.275,1.275,1.275,0,0,0-.663,1.472,2.393,2.393,0,0,0,.555.886,10.61,10.61,0,0,1,2.9,8.659,10.44,10.44,0,0,1-2.957,6.3,2.046,2.046,0,0,0-.5.829,1.281,1.281,0,0,0,.676,1.467,1.36,1.36,0,0,0,1.66-.318,13.218,13.218,0,0,0,3.905-9.279A13.931,13.931,0,0,0,3697.021,644.746Z",
    transform: "translate(-3663.083 -631.547)",
    fill: "#027fa4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUpFilled);
export default __webpack_public_path__ + "static/media/volume_up_filled.e1af89609042c399118f24ac0e0564e2.svg";
export { ForwardRef as ReactComponent };